module.exports = require('./helpers/bundle-url').getBundleURL('kXTg2') + "logo-dark.ba5147f0.svg";